import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import Header from '../../components/Header';
import Appfooter from '../../components/Appfooter';
import { Modal } from 'react-bootstrap';
import { logout } from '../../utils/session';
import LeftMenu from '../../components/LeftMenu';
import i18n from '../../utils/i18n';
import Button from '../Button';

const DefaultMenu = () => {
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  return (
    <>
      <Header />
      <LeftMenu />
      <div className="main-content right-chat-active">
        <div className="middle-sidebar-bottom">
          <div className="middle-sidebar-left">
            <div className="middle-wrap">
              <div className="card w-100 border-0 bg-white shadow-xs p-0" style={{ marginBottom: '100px' }}>
                <div className="card-body p-lg-5 p-4 w-100 border-0">
                  <div className="row">
                    <div className="col-lg-12">
                      <ul className="list-inline mb-4">
                        <li className="list-inline-item d-block border-bottom me-0">
                          <Link
                            to="/"
                            className="pt-2 pb-2 d-flex align-items-center"
                          >
                            <i className="btn-round-md bg-warning text-white feather-trending-up font-md me-3"></i>{' '}
                            <h4 className="fw-600 font-xsss mb-0 mt-0">
                              {i18n.t<string>('Menu.popular')}
                            </h4>
                          </Link>
                        </li>
                        <li className="list-inline-item d-block border-bottom me-0">
                          <Link
                            to="/feed"
                            className="pt-2 pb-2 d-flex align-items-center"
                          >
                            <i className="btn-round-md bg-warning text-white feather-unlock font-md me-3"></i>{' '}
                            <h4 className="fw-600 font-xsss mb-0 mt-0">
                              {i18n.t<string>('Menu.feed')}
                            </h4>
                          </Link>
                        </li>
                        <li className="list-inline-item d-block border-bottom me-0">
                          <Link
                            to="/following"
                            className="pt-2 pb-2 d-flex align-items-center"
                          >
                            <i className="btn-round-md bg-warning text-white feather-user-check font-md me-3"></i>{' '}
                            <h4 className="fw-600 font-xsss mb-0 mt-0">
                              {i18n.t<string>('Menu.following')}
                            </h4>
                          </Link>
                        </li>
                        <li className="list-inline-item d-block border-bottom me-0">
                          <Link
                            to="/subscriptions"
                            className="pt-2 pb-2 d-flex align-items-center"
                          >
                            <i className="btn-round-md bg-warning text-white feather-bookmark font-md me-3"></i>{' '}
                            <h4 className="fw-600 font-xsss mb-0 mt-0">
                              {i18n.t<string>('Menu.subscriptions')}
                            </h4>
                          </Link>
                        </li>
                      </ul>
                      <div className="nav-caption fw-600 font-xssss text-grey-500 mb-2">
                        {i18n.t<string>('Menu.title.account')}
                      </div>
                      <ul className="list-inline mb-4">
                        <li className="list-inline-item d-block border-bottom me-0">
                          <Link
                            to="/myprofile"
                            className="pt-2 pb-2 d-flex align-items-center"
                          >
                            <i className="btn-round-md bg-warning text-white feather-user font-md me-3"></i>{' '}
                            <h4 className="fw-600 font-xsss mb-0 mt-0">
                              {i18n.t<string>('Menu.myprofile')}
                            </h4>
                          </Link>
                        </li>
                        <li className="list-inline-item d-block border-bottom me-0">
                          <Link
                            to="/creator"
                            className="pt-2 pb-2 d-flex align-items-center"
                          >
                            <i className="btn-round-md bg-warning text-white feather-plus-square font-md me-3"></i>{' '}
                            <h4 className="fw-600 font-xsss mb-0 mt-0">
                              {i18n.t<string>('Menu.creator')}
                            </h4>
                          </Link>
                        </li>
                        {/* <li className="list-inline-item d-block border-bottom me-0">
                          <Link
                            to="/settings"
                            className="pt-2 pb-2 d-flex align-items-center"
                          >
                            <i className="btn-round-md bg-warning text-white feather-settings font-md me-3"></i>{' '}
                            <h4 className="fw-600 font-xsss mb-0 mt-0">
                              {i18n.t<string>('Menu.settings')}
                            </h4>
                          </Link>
                        </li> */}
                      </ul>
                      <div className="nav-caption fw-600 font-xssss text-grey-500 mb-2">
                        Suporte
                      </div>
                      <ul className="list-inline mb-4">
                        <li className="list-inline-item d-block border-bottom me-0">
                          <div
                            className="pt-2 pb-2 d-flex align-items-center"
                          >
                            <i className="btn-round-md bg-warning text-white feather-mail font-md me-3"></i>{' '}
                            <h4 className="fw-600 font-xsss mb-0 mt-0">
                              help@silksecret.me
                            </h4>
                          </div>
                        </li>
                      </ul>
                      <div className="nav-caption fw-600 font-xssss text-grey-500 mb-2">
                        {i18n.t<string>('Menu.title.other')}
                      </div>
                      <ul className="list-inline mb-4">
                        <li className="list-inline-item d-block border-bottom me-0">
                          <button
                            onClick={() => setShowLogoutModal(true)}
                            className="pt-2 pb-2 d-flex align-items-center border-0 bg-transparent"
                          >
                            <i className="btn-round-md bg-warning text-white feather-log-out font-md me-3"></i>{' '}
                            <h4 className="fw-600 font-xsss mb-0 mt-0">
                              {i18n.t<string>('Menu.logout')}
                            </h4>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal show={showLogoutModal}>
          <Modal.Header
            closeButton
            onClick={() => setShowLogoutModal(false)}
            className="bg-white"
            style={{
              border: 0,
              borderRadius: 0,
              padding: 20,
              borderTopLeftRadius: 10,
              WebkitBorderTopRightRadius: 10,
            }}
          />
          <Modal.Body className="bg-white">
            <p className="font-xs text-black text-center">
              {i18n.t<string>('Logout.message')}
            </p>
          </Modal.Body>
          <Modal.Footer className="bg-white d-flex flex-row">
            <div className="form-group mb-1 flex-grow-1">
              <button
                onClick={() => setShowLogoutModal(false)}
                className="form-control text-center text-white fw-600 bg-dark border-0 p-0"
              >
                {i18n.t<string>('Logout.cancel')}
              </button>
            </div>
            <div className="form-group mb-1 flex-grow-1">
              <Button
                onClick={() => {
                  logout();
                }}
              >
                {i18n.t<string>('Logout.confirm')}
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
      <Appfooter />
    </>
  );
};

export default DefaultMenu;
